



































































































import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { UserData } from '@/generated/model/userData'
import { userProfiles } from '@/api/const'
import { UserCredentials } from '@/generated/model/userCredentials'
import { errorHandler } from '@/api/utils/http-helpers'
import { Pages } from '@/pages'
import { ISnackbar } from '@/model'
import NavButton from '@/components/shared/NavButton.vue'
import { permissions } from '@/userUtils'

@Component({
  components: { NavButton },
  computed: {
    ...mapGetters('user', [ 'userData', 'allUserProfiles', 'userPermissions' ])
  }
})
export default class UserManagement extends Vue {
  private homeRouteLink: string = Pages.HOME.routeLink
  private userData!: UserData
  private userPermissions!: string[]
  private allUserProfiles!: UserData[]
  private userProfilesList = userProfiles
  private usersData: any[] = []
  private snackbar: ISnackbar = { show: false, color: '', text: '', timeout: 10000 }

  async mounted () {
    setTimeout(async () => {
      await this.createUsers()
    }, 250)
  }

  private async createUsers() {
    if (this.allUserProfiles.length < 1) {
      await this.$store.dispatch('user/getAllUserProfiles')
    }
    for (const userProfile of this.userProfilesList) {
      const userData = this.allUserProfiles.find(u => {
        return u.userName === userProfile.id
      })
      if (!userData) {
        continue
      }
      this.usersData.push({
        id: userData!.userName,
        name: userProfile.name,
        loginRequired: userData!.loginRequired,
        permissions: userData!.permissions,
        password: '',
        showPassword: false,
        showPermissions: false
      })
    }
  }

  private checkChange() {
    this.snackbar.show = false
    this.$nextTick(() => {
      if (this.isEditPasswordDisabled()) {
        this.showSnackBar('warning', String(this.$t('settings.permissionDenied')))
      }
    })
  }

  private isEditPasswordDisabled() {
    return !this.userPermissions.includes(permissions.MODIFYUSERPASSWORD)
  }

  private toggleShowPermissions(userInfo: any) {
    // this.usersData.filter(p => p.id !== userInfo.id)!.forEach(p => p.showPermissions = false)
    userInfo.showPermissions = !userInfo.showPermissions
  }

  private readPermissions(role: string) {
    const generalDesc = this.$t('userManagement.permissions.' + role + '.generalDescription')
    return (role !== 'basic' ? generalDesc + '<br/>' : '') + this.$t('userManagement.permissions.' + role + '.specialAccess')
  }

  private async updatePassword(userInfo: any) {
    this.snackbar.show = false
    const payload: UserCredentials = { userName: userInfo.id, password: userInfo.password}
    await this.$store.dispatch('user/updateUserPassword', payload)
        .then(() => {
          userInfo.password = ''
          this.showSnackBar('success', String(this.$t('userManagement.passwordChangedSuccessfully')))
        })
        .catch(error => {
          errorHandler(error)
          this.showSnackBar('error', String(this.$t('userManagement.passwordChangeFailed')))
        })
  }

  private async updatePasswordEnabled(userInfo: any) {
    this.snackbar.show = false
    await this.$store.dispatch('user/updateUserData', {
      id: userInfo.id,
      loginRequired: userInfo.loginRequired
    }).then(() => {
      this.$store.dispatch('user/getAllUserProfiles')
    }).then(() => {
      this.showSnackBar('success', String(this.$t('userManagement.userChangedSuccessfully')))
    }).catch(error => {
      userInfo.loginRequired = !userInfo.loginRequired
      errorHandler(error)
      this.showSnackBar('error', String(this.$t('userManagement.userChangeFailed')))
    })
  }

  private showSnackBar(color: string, messageText: string) {
    this.snackbar.show = true
    this.snackbar.color = color
    this.snackbar.text = messageText
  }
}
